'use client'
import React from 'react'
import { Box, Card, Stack, Typography } from '@mui/material'
import moment from 'moment'

export const AnotherMeasurementSection = ({ time, data }) => {
    return (
        <React.Fragment>
            <Stack>
                <Typography variant="body1" component={'h2'}>
                    การคัดกรองทางสุขภาพอื่นๆ
                </Typography>
                <Typography
                    variant="subtitle1"
                    fontWeight={'bold'}
                    color={'#CACACA'}
                    component={'h2'}
                >
                    ตรวจคัดกรองครั้งล่าสุดเมื่อ{' '}
                    {time
                        ? moment.unix(time).locale('th').format('llll')
                        : '- -'}
                </Typography>
            </Stack>
            <Stack direction={'row'} spacing={2}>
                <Card
                    sx={{
                        flexBasis: '100%',
                        backgroundColor: 'background.default',
                    }}
                >
                    <Box p={2}>
                        <Typography
                            variant="h6"
                            fontSize={16}
                            textAlign={'center'}
                            color={'#5F5F5F'}
                        >
                            รอบเอว (นิ้ว)
                        </Typography>
                        <Typography
                            variant="body1"
                            textAlign={'center'}
                            fontSize={24}
                        >
                            - -
                        </Typography>
                    </Box>
                </Card>
                <Card
                    sx={{
                        flexBasis: '100%',
                        backgroundColor: 'background.default',
                    }}
                >
                    <Box p={2}>
                        <Typography
                            variant="h6"
                            fontSize={16}
                            textAlign={'center'}
                            color={'#5F5F5F'}
                        >
                            การดื่มสุรา
                        </Typography>
                        <Typography
                            variant="body1"
                            textAlign={'center'}
                            fontSize={24}
                        >
                            {data?.find((item) => item.name === 'ALCOLHOL')
                                ?.value === '1'
                                ? 'ดื่มสุรา'
                                : 'ไม่ดื่มสุรา' || '- -'}
                        </Typography>
                    </Box>
                </Card>
                <Card
                    sx={{
                        flexBasis: '100%',
                        backgroundColor: 'background.default',
                    }}
                >
                    <Box p={2}>
                        <Typography
                            variant="h6"
                            fontSize={16}
                            textAlign={'center'}
                            color={'#5F5F5F'}
                        >
                            การสูบบุหรี่
                        </Typography>
                        <Typography
                            variant="body1"
                            textAlign={'center'}
                            fontSize={24}
                        >
                            {data?.find((item) => item.name === 'SMOKE')
                                ?.value === '1'
                                ? 'สูบบุหรี่'
                                : 'ไม่สูบบุหรี่' || '- -'}
                        </Typography>
                    </Box>
                </Card>
            </Stack>
        </React.Fragment>
    )
}
